import type {ReactElement} from 'react';
import type {RecurringType} from '@Components/event-wizard/recurring-event-selector/recurring-event-selector.types';
import {ALL_RECURRING_TYPES, recurringEventTypeDropdownID} from '@Components/event-wizard/recurring-event-selector/recurring-event-selector.types';
import capitalize from 'lodash/capitalize';
import {onEventWizardRecurringEndsOnChange, onEventWizardRecurringTypeChange} from '@Components/event-wizard/event-wizard-slice';
import {useDispatch} from 'react-redux';
import {
  useEventWizardEndDateTime,
  useEventWizardRecurringData,
  useEventWizardRecurringType,
  useEventWizardStartDateTime,
  useEventWizardTimeZone,
} from '@Components/event-wizard/event-wizard.hooks';
import {getMaxRecurringDate} from '@Components/event-wizard/recurring-event-selector/recurring-event-selector.helper';
import type {EventWizardRecurringTypeContentProps} from './event-wizard-recurring-type-content.types';
import styles from './event-wizard-recurring-type-content.module.scss';
import {updatePreviewDateTime} from '@Components/event-wizard/preview/preview.helper';
import {ControlledList} from '@Components/controlled-list';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';

export function EventWizardRecurringTypeContent({onSelect}: EventWizardRecurringTypeContentProps): ReactElement<any> {
  const dispatch = useDispatch();
  const startDateTime = useEventWizardStartDateTime();
  const endDateTime = useEventWizardEndDateTime();
  const recurringPattern = useEventWizardRecurringData();
  const selectedRecurringType = useEventWizardRecurringType();
  const selectedTimezone = useEventWizardTimeZone();

  const onSelectionRecurringType = (newRecurringType: RecurringType): void => {
    dispatch(onEventWizardRecurringTypeChange(newRecurringType));
    dispatch(onEventWizardRecurringEndsOnChange(getMaxRecurringDate(startDateTime, newRecurringType)));

    updatePreviewDateTime({
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      recurringPattern: {
        ...recurringPattern,
        recurringType: newRecurringType,
      },
      timeZone: selectedTimezone,
    });

    if (onSelect) {
      onSelect();
    }
  };

  return (
    <ControlledList
      id={recurringEventTypeDropdownID}
      items={ALL_RECURRING_TYPES.map((recurringTypeItem) => {
        return {
          id: `${recurringEventTypeDropdownID}_${recurringTypeItem}`,
          type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_3,
          text: capitalize(recurringTypeItem),
          isSelected: selectedRecurringType === recurringTypeItem,
          onClick(): void {
            onSelectionRecurringType(recurringTypeItem);
          },
          className: styles.listItem,
        };
      })}
    />
  );
}
